import { MutuoData, MutuoFormData } from "./calculators/calcolatore-mutuo.interface";
import { PensioneFormData } from "./calculators/calcolatore-pensione.interface";
import { InflazioneFormData } from "./calculators/calcolatore-inflazione.interface";
import { InteresseCompostoFormData } from "./calculators/calcolatore-interesse-composto.interface";
import { MultiAssetFormData } from "./calculators/calcolatore-interesse-composto-multi-asset.interface";

// Tipi di calcolatori disponibili
export enum CalculatorType {
  MUTUO = 'mutuo',
  PRESTITO = 'prestito',
  INVESTIMENTO = 'investimento',
  PENSIONE = 'pensione',
  INFLAZIONE = 'inflazione',
  INTERESSE_COMPOSTO = 'interesse-composto',
  INTERESSE_COMPOSTO_MULTI_ASSET = 'interesse-composto-multi-asset'
}

// Dati specifici per altri calcolatori (da espandere in futuro)
export interface PrestitoData {
  importo: number;
  tasso: number;
  durata: number;
}

export interface InvestimentoData {
  importoIniziale: number;
  rendimentoAnnuo: number;
  durata: number;
}

// Union type per i dati del calcolatore
export type CalculatorData = MutuoFormData | PensioneFormData | InflazioneFormData | InteresseCompostoFormData | MultiAssetFormData;

// Interfaccia principale per un calcolatore salvato
export interface SavedCalculator {
  _id: string;
  userId: string;
  type: CalculatorType;
  title: string;
  description?: string;
  inputs: CalculatorData;
  createdAt: string;
  updatedAt: string;
}

// DTO per creare un nuovo calcolatore salvato
export interface CreateSavedCalculatorDto {
  type: CalculatorType;
  title: string;
  description?: string;
  inputs: CalculatorData;
}

// DTO per aggiornare un calcolatore salvato
export interface UpdateSavedCalculatorDto {
  name?: string;
  description?: string;
  data?: CalculatorData;
}
